export const DATE_ERROR: string = 'date error';
export const INVALID_QUERY_ERROR: string = 'invalid query';
export const SLOW_QUERY_ERROR: string = 'query slow error';
export const UNABLE_TO_COPY: string = 'Unable to copy to clipboard';
